import React, { Component } from 'react';
import {
    WithStyles, createStyles
} from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) => createStyles({
    app: {
        marginTop: '40px'
    },
    progressInput: {
        margin: '20px auto',
        width: '30%',
    },
    circleBackground: {
        stroke: '#ddd',
        fill: 'none',
    },
    circleProgress: {
        stroke: 'blue',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        fill: 'none'
    },
    circleText: {
        fontSize: '2em',
        fill: 'blue',
    }
});

interface CircularProgressBarProps extends WithStyles<typeof styles> {
    sqSize: any;
    strokeWidth: any;
    percentage: any;
    classes: any;
}

interface CircularProgressBarState {
}

class CircularProgressBar extends Component<CircularProgressBarProps, CircularProgressBarState> {

    render() {
        const { classes } = this.props;
        const sqSize = this.props.sqSize;
        // SVG centers the stroke width on the radius, subtract out so circle fits in square
        const radius = (this.props.sqSize - this.props.strokeWidth) / 2;
        // Enclose cicle in a circumscribing square
        const viewBox = `0 0 ${sqSize} ${sqSize}`;
        // Arc length at 100% coverage is the circle circumference
        const dashArray = radius * Math.PI * 2;
        // Scale 100% coverage overlay with the actual percent
        const dashOffset = dashArray - dashArray * this.props.percentage / 100;

        return (
            <svg
                width={this.props.sqSize}
                height={this.props.sqSize}
                viewBox={viewBox}>
                <circle
                    className={classes.circleBackground}
                    cx={this.props.sqSize / 2}
                    cy={this.props.sqSize / 2}
                    r={radius}
                    strokeWidth={`${this.props.strokeWidth}px`} />
                <circle
                    className={classes.circleProgress}
                    cx={this.props.sqSize / 2}
                    cy={this.props.sqSize / 2}
                    r={radius}
                    strokeWidth={`${this.props.strokeWidth}px`}
                    // Start progress marker at 12 O'Clock
                    transform={`rotate(-90 ${this.props.sqSize / 2} ${this.props.sqSize / 2})`}
                    style={{
                        strokeDasharray: dashArray,
                        strokeDashoffset: dashOffset
                    }} />
                <text
                    className={classes.circleText}
                    x="50%"
                    y="50%"
                    dy=".3em"
                    textAnchor="middle">
                    {`${this.props.percentage}%`}
                </text>
            </svg>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {}
};

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
}, dispatch);
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CircularProgressBar));